import script from "./ALMA.vue?vue&type=script&lang=js"
export * from "./ALMA.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__